/* eslint-disable no-useless-escape */
import { LoggedInUser } from '@/entities/auth/loggedInUser';
import { emptyOrganization } from '@/ui/auth/emptyOrganization';
import { PlatformEnum } from '@/ui/pages/subscription/common/PlatformEnum';

export const emptyUser: LoggedInUser = {
  _legacy_pays_by_invoice: 0,
  _legacy_has_hardware: 0,
  subscription: null,
  subscriberAccount: null,
  subscriberPlatform: PlatformEnum.Chargebee,
  subscriptionFeatures: [],
  subscriptionQuotas: [],
  id: 0,
  name: '',
  email: '',
  phoneNumber: '',
  locale: 'en',
  timezone: '',
  timezoneId: '',
  unreadNotifications: 0,
  createdAt: new Date(),
  organization: emptyOrganization(),
  permissions: [],
  admin: false,
  role: null,
  features: {
    sso_enabled: false,
    integrations_enabled: false,
    chargebee_enabled: true,
    analytics_enabled: true,
    onboarding_enabled: true,
    ai_template_enabled: false,
    entities_upload_enabled: false,
    entity_type_of_response_enabled: false,
    session_limitation_enabled: false,
    average_weighted_score_calculation_enabled: false,
    tbr_enabled: false,
    file_type_of_response_enabled: false,
    disable_free_plan_enabled: false,
    approvals_enabled: false,
    discount_for_churns_enabled: false,
    report_view_restrictions_enabled: false,
    rocc_scoring_enabled: false,
    form_translations_enabled: false,
    manual_form_translations_enabled: false,
    rte_enabled: false,
    ai_pricing_enabled: false,
    ai_chat_enabled: false,
    ai_image_description_enabled: false,
    entity_properties_enabled: false,
    entity_property_prefill_enabled: false,
    last_login_enabled: false,
    ai_pack_enabled: false,
    word_template_report_enabled: false,
    ai_blur_faces_enabled: false,
    ai_image_validation_enabled: false,
    ai_improve_writing_enabled: false,
  },
  analytics: {
    id: '',
    issuesCreated: 0,
    completedInspections: 0,
  },
  appDownloaded: false,
  shownTours: [],
  entityItems: [],
  _legacy_subscription: {
    name: '',
    status: '',
    quantity: 0,
    interval: '',
    organization_id: 0,
    users: {
      count: 0,
      initial_count: 0,
      limit: 0,
      limit_reached: false,
    },
    trial_ends_at: null,
    next_charge_at: 0,
    next_charge_amount: '0.00',
    canceled_at: 0,
    ends_at: 0,
    is_free: false,
    plan: {
      name: '',
      slug: '',
      is_free: false,
      nickname: '',
      currency: '',
      interval: '',
      active: 0,
      amount: '0.00',
      trial_period_days: 0,
      tiers: [
        {
          unit_amount: '0.00',
          up_to: null,
        },
      ],
    },
    billing_details: {
      name: '',
      email: '',
      card: {
        number: '',
        expiry: '',
        brand: '',
      },
      address: '',
      zip: '',
      city: '',
      country: '',
      vat: null,
    },
    //will be same as _legacy_subscription
    next_subscription: null,
  },
  formTranslationsLocale: null,
  aiWallet: {
    monthly: 1000,
    available: 0,
  },
};
